import UAParser from 'ua-parser-js';

export function UserAgentInfo() {
  // 创建一个 UserAgentParser 实例
  const parser = new UAParser();

  // 解析用户代理字符串
  const uaResult = parser.getResult();
  return {
    osVersion: uaResult.os.name,
    browserBrand: uaResult.browser.name,
    browserVersion: uaResult.browser.version
  };
}

/** true: PC  false: 移动 */
export const terminal = !!!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

export const emailSuffix = ['@gmail.com', '@yahoo.com', '@hotmail.com', '@aol.com', '@icloud.com', '@outlook.com'];
